import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/arrow_bear_right_grey.svg'
import _imports_1 from '@/assets/icons/arrow_bear_right.svg'
import _imports_2 from '@/assets/icons/delete-button-icon.svg'


const _withScopeId = n => (_pushScopeId("data-v-48cf4482"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "popup-container"
}
const _hoisted_2 = { class: "container d-flex flex-column h-100" }
const _hoisted_3 = { class: "row flex-grow-0" }
const _hoisted_4 = { class: "col-11 d-flex flex-column align-items-start justify-content-center" }
const _hoisted_5 = { class: "d-flex align-items-center gap-2" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "building-icon"
}, null, -1))
const _hoisted_7 = { class: "popup-title-text" }
const _hoisted_8 = { class: "popup-sub-title" }
const _hoisted_9 = { class: "col-1" }
const _hoisted_10 = { class: "drawer-content" }
const _hoisted_11 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_12 = { class: "mt-3 mb-3" }
const _hoisted_13 = ["disabled", "placeholder"]
const _hoisted_14 = {
  key: 0,
  class: "agencies-list"
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "pagination-container" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = { class: "page-info" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = { class: "actions-container mt-3" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_25 = ["disabled"]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "",
  class: "delete-icon"
}, null, -1))

import { ref, onMounted, computed, watch } from "vue";
import LbrxErrorNotification from "./LbrxErrorNotification.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'LbrxTargetQueuesDrawer',
  props: {
  modelValue: {
    type: Boolean,
    default: false,
  },
  queues: {
    type: Array,
    required: true,
  },
},
  emits: ["close", "redirect"],
  setup(__props, { emit }) {

const props = __props;

_useCssVars(_ctx => ({
  "7530c399": (_unref(FixBoxWidth))
}))





const showPopup = ref(false);

const closeThis = () => {
  showPopup.value = false;
  setTimeout(() => {
    emit("close");
  }, 700);
};

const searchQuery = ref("");
const selectedQueue = ref<any>(null);
const currentPage = ref(1);
const itemsPerPage = 10;
const showError = ref(false);
const loading = ref(false);

const filteredQueues = computed(() => {
  if (!props.queues || !Array.isArray(props.queues)) return [];
  if (!searchQuery.value.trim()) return props.queues;
  const q = searchQuery.value.toLowerCase();
  return props.queues.filter(
    (queue: any) =>
      queue && queue.title && queue.title.toLowerCase().includes(q)
  );
});

const paginatedQueues = computed(() => {
  if (!filteredQueues.value || !Array.isArray(filteredQueues.value)) return [];
  const start = (currentPage.value - 1) * itemsPerPage;
  return filteredQueues.value.slice(start, start + itemsPerPage);
});

const totalPages = computed(() => {
  if (!filteredQueues.value || !Array.isArray(filteredQueues.value)) return 0;
  return Math.ceil(filteredQueues.value.length / itemsPerPage) || 1;
});

const isSelected = (queue: any) => {
  if (!queue || selectedQueue.value == null) return false;
  return (queue.id != null && queue.id === selectedQueue.value?.id) ||
    queue === selectedQueue.value;
};

const selectQueue = (queue: any) => {
  if (loading.value || !queue) return;
  if (isSelected(queue)) {
    selectedQueue.value = null;
  } else {
    selectedQueue.value = queue;
  }
};

const nextPage = () => {
  if (currentPage.value < totalPages.value) currentPage.value++;
};

const prevPage = () => {
  if (currentPage.value > 1) currentPage.value--;
};

const handleSearchChange = () => {
  if (!loading.value) currentPage.value = 1;
};

const redirectToQueue = () => {
  if (!selectedQueue.value) {
    showError.value = true;
    return;
  }
  showError.value = false;
  console.log("selectedQueue", selectedQueue.value);
  emit("redirect", selectedQueue.value);
//   closeThis();
};

const FixBoxWidth = computed(() => "45%");

watch(
  () => props.modelValue,
  (newValue) => {
    if (newValue) {
      searchQuery.value = "";
      selectedQueue.value = null;
      currentPage.value = 1;
      showError.value = false;
      setTimeout(() => {
        showPopup.value = true;
      }, 5);
    } else {
      showPopup.value = false;
      searchQuery.value = "";
      selectedQueue.value = null;
      currentPage.value = 1;
      showError.value = false;
    }
  },
  { immediate: true }
);

onMounted(() => {
  document.addEventListener("keyup", (e) => {
    if (e.key === "Escape") closeThis();
  });
});

return (_ctx: any,_cache: any) => {
  return (__props.modelValue)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_Transition, null, {
          default: _withCtx(() => [
            (showPopup.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["popup-box", { 'right-class': _ctx.$i18n.locale === 'ar' }])
                }, [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                          _hoisted_6,
                          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t("Teller.Redirect_ticket")), 1)
                        ]),
                        _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("Teller.redirectQueueTxt")), 1)
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", {
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (closeThis())),
                          class: "close-popup"
                        }, "X")
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      (showError.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            _createVNode(LbrxErrorNotification, {
                              label: _ctx.$t('Teller.PleaseSelectQueue'),
                              color: "#FF5757",
                              background: "rgba(255, 158, 152, 0.5)",
                              height: "6",
                              width: "100%",
                              "font-size": "0.7",
                              icon: "error-icon"
                            }, null, 8, ["label"])
                          ]))
                        : _createCommentVNode("", true),
                      (__props.queues.length > 0)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createElementVNode("div", _hoisted_12, [
                              _withDirectives(_createElementVNode("input", {
                                disabled: loading.value,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchQuery).value = $event)),
                                type: "text",
                                placeholder: _ctx.$t('Teller.SearchQueue'),
                                class: "search-input",
                                onInput: handleSearchChange
                              }, null, 40, _hoisted_13), [
                                [_vModelText, searchQuery.value]
                              ])
                            ]),
                            (_unref(paginatedQueues).length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(paginatedQueues), (queue, index) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: queue?.id || index,
                                      class: _normalizeClass(["agency-item", {
                    selected: isSelected(queue),
                    disabled: loading.value,
                  }]),
                                      onClick: ($event: any) => (!loading.value && selectQueue(queue))
                                    }, [
                                      _createElementVNode("span", null, _toDisplayString(queue?.title || "Unknown Queue"), 1)
                                    ], 10, _hoisted_15))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_16, [
                              _createElementVNode("button", {
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (!loading.value && prevPage())),
                                disabled: currentPage.value === 1 || loading.value,
                                class: "pagination-button"
                              }, _toDisplayString(_ctx.$t("Teller.Previous")), 9, _hoisted_17),
                              _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t("Teller.Page")) + " " + _toDisplayString(currentPage.value) + " " + _toDisplayString(_ctx.$t("Teller.of")) + " " + _toDisplayString(_unref(totalPages)), 1),
                              _createElementVNode("button", {
                                onClick: _cache[3] || (_cache[3] = ($event: any) => (!loading.value && nextPage())),
                                disabled: currentPage.value === _unref(totalPages) || loading.value,
                                class: "pagination-button"
                              }, _toDisplayString(_ctx.$t("Teller.Next")), 9, _hoisted_19)
                            ])
                          ], 64))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("button", {
                          class: "btn btn-primary",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (redirectToQueue())),
                          disabled: loading.value
                        }, [
                          (loading.value)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_ctx.$t("Teller.Redirecting")), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_23, [
                                _hoisted_24,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t("Teller.Redirect")), 1)
                              ]))
                        ], 8, _hoisted_21),
                        _createElementVNode("button", {
                          class: "btn btn-secondary d-flex align-items-center justify-content-center gap-2",
                          disabled: loading.value,
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (closeThis()))
                        }, [
                          _hoisted_26,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t("Teller.Cancel")), 1)
                        ], 8, _hoisted_25)
                      ])
                    ])
                  ])
                ], 2))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}
}

})